import { makeStyles, Typography } from '@material-ui/core'

import TrialImage from 'assets/images/week-trial-end.png'

import { DialogBody } from './DialogBody'

import { useRoles } from 'hooks'

import { calculateDaysLeft, openLink } from 'modules'

import { showPlanDialog } from 'ducks'
import { useDispatch } from 'react-redux'

const green = 'rgba(233, 242, 153, 0.9)'
const blue = 'rgba(152, 226, 236, 0.9)'

type Props = {
    onClose: () => void
    date: number
}

const useStyles = makeStyles(theme => ({
    secondaryAction: {
        cursor: 'pointer',
        textDecoration: 'underline',
        color: '#001a36',
        marginTop: theme.spacing(2)
    }
}))

export const TrialWeekToEndDialog = ({ onClose, date }: Props) => {
    const { isAdmin } = useRoles()
    const classes = useStyles()

    const dispatch = useDispatch()

    const days = calculateDaysLeft(date)
    const openDemoPage = () => {
        openLink('https://meetings.hubspot.com/ngiat/book-a-demo-with-guidde', '_blank')
    }

    return (
        <DialogBody
            isOpen
            skipAdmin
            onClose={onClose}
            image={TrialImage}
            bubblesBackground={[green, blue]}
            onPrimaryClick={() => {
                if (isAdmin) {
                    dispatch(showPlanDialog('upgradePlanDialog'))
                } else {
                    openDemoPage()
                }
            }}
            primaryText={isAdmin ? 'See plans' : 'Book a demo'}
            secondaryButton={
                <>
                    {isAdmin && (
                        <Typography
                            variant="subtitle2"
                            className={classes.secondaryAction}
                            onClick={openDemoPage}
                        >
                            Book a demo
                        </Typography>
                    )}
                </>
            }
            title={`Your trial ends in ${days} ${days === 1 ? 'day' : 'days'}`}
            text={
                <Typography>
                    Are you making use of your trial as best as possible? Don’t forget to try out
                    custom branding and blurring out sensitive information.
                </Typography>
            }
        />
    )
}
